@if (shellVisible) {
  <app-shell [orders]="userOrders" [supplier]="supplier"></app-shell>
}

@if (!shellVisible && (startupState === startupStates.REDIRECTING || startupState === startupStates.ERROR)) {
  <div class="status-wrapper">
    @if (startupState === startupStates.REDIRECTING) {
      <p class="status-message">Redirecting to sign in...</p>
    }

    @if (startupState === startupStates.ERROR) {
      <p class="status-error">{{ loadingError }}</p>
    }
  </div>
}
